/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./risA.vue?vue&type=template&id=00396986"
import script from "./risA.vue?vue&type=script&lang=js"
export * from "./risA.vue?vue&type=script&lang=js"
import style0 from "./risA.vue?vue&type=style&index=0&id=00396986&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports